import { Hidden } from "@material-ui/core";
import DeskHeader from "./desktopHeader";
import MobHeader from "./mobileHeaders";

export default function Header() {
 

  return (
    <>
      <Hidden smDown>
        <DeskHeader />
      </Hidden>
      <Hidden mdUp>
        <MobHeader />
      </Hidden>
    </>
  );
}
